import { render, staticRenderFns } from "./Togglebuttons.vue?vue&type=template&id=27402395&scoped=true"
import script from "./Togglebuttons.vue?vue&type=script&lang=ts"
export * from "./Togglebuttons.vue?vue&type=script&lang=ts"
import style0 from "./Togglebuttons.vue?vue&type=style&index=0&id=27402395&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27402395",
  null
  
)

export default component.exports